export const CreateOitivaConstants = {
  OPEN_DATE: "audiences.expectedDate",
  TIME: "common.time",
  TYPES: "labels.types",
  ATTENDANTS: "participants.title",
  CONFIDENTIAL: "audiences.confidential",
  FILL_FIELDS_TITLE: "audiences.messages.fillFields",
  FILL_FIELDS_DESCRIPTION: "audiences.messages.fillFieldsDescription",
  INVALID_DATE_TITLE: "recording.invalidDateTime",
  INVALID_DATE_DESCRIPTION: "recording.invalidDateTimeDescription",
  CREATED_TITLE: "recording.created",
  CREATED_DESCRIPTION: "recording.createdDescription",
  EDITED_TITLE: "recording.edited",
  EDITED_DESCRIPTION: "recording.editedDescription",
  EDIT_ERROR_DESCRIPTION: "recording.editErrorDescription",
  NOT_FOUND_TITLE: "common.error",
  NOT_FOUND_DESCRIPTION: "recording.notFound",
};
